import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { SuggestionGroup, Suggestion } from 'js/social/shared/types';

export type SuggestionGroupsPayload = {
  groups: SuggestionGroup[];
  count: number;
  has_more: boolean;
};

export type DiscoverAcademicsPayload = {
  suggestions: Suggestion[];
};

export const getSuggestionGroups = async (
  count: number,
  page?: string,
): Promise<SuggestionGroupsPayload> => {
  const response = await fetchWithCsrf(
    routes.api_v0_suggestions_following_index_path({
      subdomain_param: 'api',
      count,
      grouped: true,
      page,
    }),
  );
  if (!response.ok) {
    throw new Error('Failed to fetch user relations');
  }
  return await response.json();
};

export const getDiscoverAcademics =
  async (): Promise<DiscoverAcademicsPayload> => {
    const response = await fetchWithCsrf(
      routes.discover_academics_api_v0_suggestions_following_index_path({
        subdomain_param: 'api',
      }),
    );

    if (!response.ok) {
      throw new Error('Failed to fetch discover academics');
    }
    return await response.json();
  };

export const getSuggestedAffiliation = async () => {
  const response = await fetchWithCsrf(
    routes.api_v0_suggestions_affiliation_path({
      subdomain_param: 'api',
    }),
  );

  if (!response.ok) {
    throw new Error('Failed to fetch suggestion affiliation');
  }
  return await response.json();
};
